module.exports = __webpack_public_path__ + "media/images/plans/plan-detail-background-proposal-1-97a0d3d8d15732d530fe657b3eba1541.jpg";